import { LogLevel, createInstance } from '@optimizely/optimizely-sdk';
import { getHoustonOptimizelySdkOptions } from '@scm-italy/js-event-dispatcher';

const houstonEnvMap = new Map([
    ['dev', 'pre'],
    ['stage', 'pre'],
    ['prod', 'pro'],
]);
const defaultUserIdPrefix = 'sdrn:subito.it:user:';
const getSubitoOptions = ({ env, userIdPrefix = defaultUserIdPrefix, collectorPath, collectorDomain, urlTemplates, }) => {
    return getHoustonOptimizelySdkOptions({
        tenant: 'subito',
        providerId: 'sdrn:schibsted:client:subito',
        environment: houstonEnvMap.get(env) ?? 'pro',
        eventDispatcherOptions: {
            userIdPrefix,
            ...(collectorPath ? { collectorPath } : {}),
            ...(collectorDomain ? { collectorDomain } : {}),
            ...(urlTemplates ? { urlTemplates } : {}),
        },
    });
};

const StringLevels = new Map([
    [LogLevel.ERROR, 'ERROR'],
    [LogLevel.WARNING, 'WARN'],
    [LogLevel.INFO, 'INFO'],
    [LogLevel.DEBUG, 'DEBUG'],
    [LogLevel.NOTSET, 'DEBUG'],
]);
class CustomLogger {
    logger;
    constructor(logger) {
        this.logger = logger;
    }
    log(level, message) {
        const msg = `[OPTIMIZELY][${StringLevels.get(level) ?? StringLevels.get(LogLevel.DEBUG)}] ${message}`;
        if (level === LogLevel.ERROR) {
            this.logger.logError(msg);
        }
        else if (level === LogLevel.WARNING) {
            this.logger.logWarn(msg);
        }
        else if (level === LogLevel.INFO) {
            this.logger.logInfo(msg);
        }
    }
}

/**
 * This value, used as collectorPath, make the dispatcher work also on server side.
 * So we can just use the frontend collector instead of handling the credentials for the backend one.
 */
const HOUSTON_FRONTEND_COLLECTOR = 'api/v1/track';
const HOUSTON_COLLECTOR_DOMAIN = 'https://collector.mpianalytics.com';
const HOUSTON_URL_TEMPLATE = Object.freeze({
    dev: 'https://assets.piutardi.it/v2/houston/experiments/%s',
    pre: 'https://assets.piutardi.it/v2/houston/experiments/%s',
    pro: 'https://assets.subito.it/v2/houston/experiments/%s',
});
/**
 * Creates an instance of the Optimizely Houston integration SPECIFIC FOR server
 * Is different from houston-wrapper because it uses the react optimizely sdk
 *
 * N.B. The instance returned here must be disposed of with the `.close()` method when it is no longer needed.
 *
 * @param env The env "dev", "stage" or "prod"
 * @param userIdPrefix The optional prefix to add to all identifiers. This can save repetition but use it carefully.
 * @param configOverride This optional param can be used to override the default logger
 */
const createOptimizelyInstance = (env, userIdPrefix, logger) => createInstance({
    ...getSubitoOptions({
        env,
        userIdPrefix,
        collectorPath: HOUSTON_FRONTEND_COLLECTOR,
        collectorDomain: HOUSTON_COLLECTOR_DOMAIN,
        urlTemplates: HOUSTON_URL_TEMPLATE,
    }),
    ...(logger ? { logger: new CustomLogger(logger) } : {}),
});

/**
 * A utility constant as a safe default when UUIDs might not always be populated
 */
const zeroUUID = '00000000-0000-0000-0000-000000000000';

export { createOptimizelyInstance, getSubitoOptions as getOptimizelySdkOptions, defaultUserIdPrefix as userIdPrefix, zeroUUID };
//# sourceMappingURL=index.js.map
